var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAllFiles({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.90801 5.25V9.1834C5.91255 9.47102 6.03 9.74533 6.23501 9.94713C6.44002 10.1489 6.71615 10.262 7.00381 10.262C7.29147 10.262 7.5676 10.1489 7.77261 9.94713C7.97762 9.74533 8.09507 9.47102 8.09961 9.1834L8.10316 4.02773C8.10615 3.78189 8.0603 3.53791 7.96829 3.30992C7.87627 3.08193 7.73992 2.87447 7.56713 2.69957C7.39434 2.52467 7.18855 2.38581 6.96169 2.29104C6.73484 2.19626 6.49142 2.14746 6.24557 2.14746C5.99971 2.14746 5.7563 2.19626 5.52944 2.29104C5.30258 2.38581 5.0968 2.52467 4.92401 2.69957C4.75122 2.87447 4.61486 3.08193 4.52285 3.30992C4.43083 3.53791 4.38499 3.78189 4.38797 4.02773V9.21812C4.38296 9.56423 4.4468 9.90788 4.57579 10.2291C4.70477 10.5503 4.89632 10.8427 5.1393 11.0892C5.38228 11.3357 5.67185 11.5315 5.99116 11.6651C6.31047 11.7987 6.65316 11.8675 6.9993 11.8675C7.34544 11.8675 7.68812 11.7987 8.00744 11.6651C8.32675 11.5315 8.61631 11.3357 8.85929 11.0892C9.10227 10.8427 9.29382 10.5503 9.42281 10.2291C9.55179 9.90788 9.61563 9.56423 9.61062 9.21812V4.36789",
    stroke: "#444746",
    strokeWidth: 0.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAllFiles);
export default __webpack_public_path__ + "static/media/all-files.3ad2a60b8836705e21baada092b0805a.svg";
export { ForwardRef as ReactComponent };